import { EmpBasicData } from '~/data/employee';
import { fetchFromOldApi } from '~/services/Http';

export interface Country {
  code: string;
  name: string;
  description?: string;
}

export interface OrgUnitType {
  code: string;
  description?: string;
  editableByEmp: boolean;
  groupName: string;
  isActive: boolean;
  name: string;
}

export const putEmpProfileData = async (json: EmpBasicData, iEmpId: number) => {
  return await fetchFromOldApi('/form/employee/' + iEmpId + '/basic', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(json),
  }).then((r) => r.json());
};

export const getCompanyCountries = (): Promise<Country[]> => {
  return fetchFromOldApi('/json/enum/ALL/jsonEnumALL')
    .then((r) => r.json())
    .then((r) => r.COUNTRY);
};

export const getCompanyOrgUnitTypes = (): Promise<OrgUnitType[]> => {
  return fetchFromOldApi('/json/enum/ALL/jsonEnumALL')
    .then((r) => r.json())
    .then((r) => r.UNIT_TYPE);
};

export enum PeopleModuleBasicDataAccessMode {
  Limited = 'limited',
  ITAdmin = 'itAdmin',
  HRDevRestricted = 'hrDevRestricted',
  Full = 'full',
}
